"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _DesignComponents = require("../DesignComponents/DesignComponents");

var _TaskDragDrop = require("./TaskDragDrop");

require("./Droppable.css");

var DEBUG = false;

function DroppableDropdown(_ref) {
  var onlyDropdown = _ref.onlyDropdown,
      choices = _ref.choices,
      unplacedChoices = _ref.unplacedChoices,
      hotspot = _ref.hotspot,
      hotspotLabel = _ref.hotspotLabel,
      labelId = _ref.labelId,
      accessibleLocation = _ref.accessibleLocation,
      placeholder = _ref.placeholder,
      updateHotspotsAfterDrop = _ref.updateHotspotsAfterDrop,
      dropdownPlacement = _ref.dropdownPlacement,
      submit = _ref.submit,
      dropdownReset = _ref.dropdownReset,
      children = _ref.children;

  if (hotspotLabel === undefined && labelId === undefined) {
    throw new Error("DroppableDropdown: prop 'hotspotLabel' or 'labelId' must be specified in order to be accessibile");
  }

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      selectedOnce = _React$useState2[0],
      setSelectedOnce = _React$useState2[1];

  var options = [];
  choices.forEach(function (choice, i) {
    if (choice.accessibleLabel === undefined) {
      throw new Error("Droppable: choice " + i + " was missing an accessible label.");
    }

    if (unplacedChoices && !unplacedChoices.includes(choice.choiceIndex)) {
      return undefined;
    }

    var dropdownContent = choice.accessible ? choice.accessible : choice.content;
    options.push( /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown.Option, {
      key: choice.index,
      value: "".concat(choice.index),
      label: choice.accessibleLabel
    }, dropdownContent));
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !(!submit && children.length && !onlyDropdown) && /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown, {
    key: hotspotLabel || labelId,
    className: "accessible-droppable",
    label: hotspotLabel,
    labelId: labelId,
    labelBottom: true,
    disabled: !submit && children.length,
    isValid: children.length ? true : selectedOnce ? false : null,
    placement: dropdownPlacement,
    value: dropdownReset,
    placeholder: placeholder,
    onChange: function onChange(e) {
      DEBUG && console.log("DroppableDropdown onChange value", e.value);

      if (e.value !== "" && e.value !== undefined) {
        var ids = choices[e.value].sourceArray.split(";");
        DEBUG && console.log("DroppableDropdown onChange", ids, accessibleLocation);
        updateHotspotsAfterDrop(ids, accessibleLocation);
        setSelectedOnce(true);
      }
    }
  }, options), !onlyDropdown && /*#__PURE__*/_react.default.createElement("div", {
    className: "inner"
  }, children));
}

var Droppable = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Droppable, _React$Component);

  var _super = (0, _createSuper2.default)(Droppable);

  function Droppable(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Droppable);
    _this = _super.call(this, props);
    _this.state = {
      hadChildren: props.children.length !== 0
    };
    _this.ref = /*#__PURE__*/_react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(Droppable, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement(_TaskDragDrop.TaskDragDropContext.Consumer, null, function (value) {
        if (_this2.ref.current && _this2.props.dragElement) {
          var node = _this2.ref.current.getBoundingClientRect();

          if (node.left <= value.mouseX && // Left
          node.right >= value.mouseX && // Right
          node.top + window.scrollY <= value.mouseY && // Top
          node.bottom + window.scrollY >= value.mouseY) {
            if (!_this2.props.hovered) _this2.props.onHover();
          } else {
            if (_this2.props.hovered) _this2.props.onEndHover();
          }
        } else {
          if (_this2.props.hovered) _this2.props.onEndHover();
        }

        if (_this2.props.children.length !== 0 && !_this2.state.hadChildren) {
          _this2.setState({
            hadChildren: true
          });
        }

        return /*#__PURE__*/_react.default.createElement("div", {
          ref: _this2.ref,
          className: "droppable" + (_this2.props.active ? " active " : " ") + (_this2.props.hovered ? " hovered " : " ") + (!_this2.props.completed ? "wordbank-color " : " ") + (_this2.props.className || ""),
          style: _this2.props.style
        }, !_this2.props.className.startsWith("wordbank") ? /*#__PURE__*/_react.default.createElement(DroppableDropdown, {
          onlyDropdown: _this2.props.onlyDropdown,
          dropdownReset: _this2.props.dropdownReset,
          choices: _this2.props.choices,
          unplacedChoices: _this2.props.unplacedChoices,
          hotspot: _this2.props.hotspot,
          hotspotLabel: _this2.props.hotspotLabel,
          labelId: _this2.props.labelId,
          accessibleLocation: _this2.props.accessibleLocation,
          placeholder: _this2.props.placeholder,
          updateHotspotsAfterDrop: _this2.props.updateHotspotsAfterDrop,
          dropdownPlacement: _this2.props.dropdownPlacement,
          submit: _this2.props.submit,
          children: _this2.props.children
        }) : /*#__PURE__*/_react.default.createElement("div", {
          className: "inner"
        }, _this2.props.children));
      });
    }
  }]);
  return Droppable;
}(_react.default.Component);

var _default = Droppable;
exports.default = _default;